import { render, staticRenderFns } from "./PageEmailNotificationsSettings.vue?vue&type=template&id=2d026a46&"
import script from "./PageEmailNotificationsSettings.vue?vue&type=script&lang=ts&"
export * from "./PageEmailNotificationsSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports